import StatsBySubject from './StatsBySubject';

export default StatsBySubject;
